function shuffle(items) {
  let i = items.length;
  let tmp, j;
  while (i > 0) {
    j = Math.floor(Math.random() * i);
    i--;
    tmp = items[i];
    items[i] = items[j];
    items[j] = tmp;
  }
}

export default shuffle;
